<script lang="ts" setup>
import type { ITableColumnsOptions } from '@modules/tables/types';
import VButton from '@components/buttons/VButton/VButton.vue';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import {
  TRANSLATION_ADMIN_PLAYERS_BONUSES,
} from '@modules/players-bonuses/constants';
import { usePlayersBonusesListQuery } from '@modules/players-bonuses/queries';
import {
  ADMIN_PLAYERS_BONUSES_CREATE_ROUTE_NAME,
  PLAYER_BONUS_CREATE_PERMISSIONS,
} from '@modules/players-bonuses/submodules/create/constants';
import { ADMIN_PLAYERS_BONUSES_EDIT_ROUTE_NAME } from '@modules/players-bonuses/submodules/edit/constants';
import VTable from '@modules/tables/components/VTable/VTable.vue';
import { useTableData } from '@modules/tables/composables';

import { usePlayersBonusesList } from './composables';

const {
  handleDelete,
} = usePlayersBonusesList();

const {
  tableState,
  isLoading,
  isFetching,
  data,
  updateTableState,
  refreshTableData,
} = useTableData(usePlayersBonusesListQuery);

const columnOptions: ITableColumnsOptions = {
  cid: {
    defaultMobilePreview: true,
  },
  aasm_state: {
    localization: {
      translationPath: 'admin.partnership_program.conditions.create_edit.steps.product.rs.',
    },
  },
};
</script>

<template>
  <VCard v-data-qa-auto-id="'PlayersBonusesListPage'" type="table">
    <VTable
      :state="tableState"
      :data="data"
      :loading="isLoading"
      :is-fetching="isFetching"
      :title-t-path="$getTPath(TRANSLATION_ADMIN_PLAYERS_BONUSES, 'PLAYERS_BONUSES_LIST_HEADER')"
      :columns-options="columnOptions"
      @state-update="updateTableState"
      @refresh="refreshTableData"
    >
      <template #recordAction="{ listItem }">
        <VIconButton
          icon="pi-file-edit"
          :to="{ name: ADMIN_PLAYERS_BONUSES_EDIT_ROUTE_NAME, params: { id: String(listItem.id) } }"
        />
        <VIconButton
          :loading="isLoading"
          icon="pi-trash"
          @click="handleDelete($event, listItem.id)"
        />
      </template>
      <template
        v-if="$hasPermission(PLAYER_BONUS_CREATE_PERMISSIONS.PLAYER_BONUS_CREATE)"
        #footerButtons
      >
        <VButton
          :to="{ name: ADMIN_PLAYERS_BONUSES_CREATE_ROUTE_NAME }"
          :label="$getTranslation(TRANSLATION_ADMIN_PLAYERS_BONUSES, 'PLAYERS_BONUSES_LIST_ADD_BONUS')"
        />
      </template>
    </VTable>
  </VCard>
</template>
